import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';
import { SelectWithCreation } from '@/components/ui/Inputs';
import type { InputDefaultProps } from '../types';

export function Company({ fieldName, isLoading = false, data = [] }: Readonly<InputDefaultProps>): JSX.Element {
	return (
		<Col span={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label isRequired>{I18n.get('Industrial site')}</Label>
				</Col>
				<Col span={24}>
					<FormItem name={[fieldName, 'company_id']}>
						<SelectWithCreation size="large" loading={isLoading} selectOptions={data} disabled />
					</FormItem>
				</Col>
			</Row>
		</Col>
	);
}
